namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceAddressForm {
        MbId: Serenity.LookupEditor;
        CusTaxTypeFg: Serenity.RadioButtonEditor;
        TaxInvName: Serenity.StringEditor;
        TaxId: Serenity.StringEditor;
        TaxBranchName: Serenity.StringEditor;
        TaxBranchNo: Serenity.StringEditor;
        TaxInvAddressLine1: Serenity.StringEditor;
        TaxInvAddressLine2: Serenity.StringEditor;
        TaxInvAddressLine3: Serenity.StringEditor;
        TaxPostalCode: Serenity.StringEditor;
        TaxCountryCode: Serenity.StringEditor;
        TelNo: Serenity.StringEditor;
        TaxEmail: Serenity.StringEditor;
    }

    export class PsTaxInvoiceAddressForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsTaxInvoiceAddress';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsTaxInvoiceAddressForm.init)  {
                PsTaxInvoiceAddressForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.RadioButtonEditor;
                var w2 = s.StringEditor;

                Q.initFormType(PsTaxInvoiceAddressForm, [
                    'MbId', w0,
                    'CusTaxTypeFg', w1,
                    'TaxInvName', w2,
                    'TaxId', w2,
                    'TaxBranchName', w2,
                    'TaxBranchNo', w2,
                    'TaxInvAddressLine1', w2,
                    'TaxInvAddressLine2', w2,
                    'TaxInvAddressLine3', w2,
                    'TaxPostalCode', w2,
                    'TaxCountryCode', w2,
                    'TelNo', w2,
                    'TaxEmail', w2
                ]);
            }
        }
    }
}
